import { useMemo } from "react";
import Constant from "../utils/constants";
import { domainDetails } from "../utils/domainDetails";

const { domainList } = Constant;

export const useDomainConfig = () => {
  return useMemo(() => {
    const hostSubArray = window.location.host.split(".");
    const domain = hostSubArray[hostSubArray.length - 2];
    return domainDetails[domain] ?? domainDetails[domainList.AMIKTECHNOLOGIES];
  }, []); // Empty dependency array since window.location.host doesn't change during app lifecycle
};
